/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 29a5f4f6c5c6
 */

import * as z from "zod";

export type VisualSearchParameters3 = {
  text: string;
  threshold?: number | undefined;
};

export const VisualSearchParameters3$zodSchema: z.ZodType<
  VisualSearchParameters3
> = z.object({
  text: z.string().describe(
    "A textual description to find visually similar images",
  ),
  threshold: z.number().optional().describe(
    "The minimum similarity score (between 0 and 1.0) that a resource must have to be included in the response",
  ),
});

export type VisualSearchParameters2 = {
  image_asset_id: string;
  threshold?: number | undefined;
};

export const VisualSearchParameters2$zodSchema: z.ZodType<
  VisualSearchParameters2
> = z.object({
  image_asset_id: z.string().describe(
    "The asset ID of an existing image to use as the source for finding visually similar images",
  ),
  threshold: z.number().optional().describe(
    "The minimum similarity score (between 0 and 1.0) that a resource must have to be included in the response",
  ),
});

export type VisualSearchParameters1 = {
  image_url: string;
  threshold?: number | undefined;
};

export const VisualSearchParameters1$zodSchema: z.ZodType<
  VisualSearchParameters1
> = z.object({
  image_url: z.string().describe(
    "The URL of an image to use as the source for finding visually similar images",
  ),
  threshold: z.number().optional().describe(
    "The minimum similarity score (between 0 and 1.0) that a resource must have to be included in the response",
  ),
});

/**
 * Parameters for visual search operations
 */
export type VisualSearchParametersUnion =
  | VisualSearchParameters1
  | VisualSearchParameters2
  | VisualSearchParameters3;

export const VisualSearchParametersUnion$zodSchema: z.ZodType<
  VisualSearchParametersUnion
> = z.union([
  z.lazy(() => VisualSearchParameters1$zodSchema),
  z.lazy(() => VisualSearchParameters2$zodSchema),
  z.lazy(() => VisualSearchParameters3$zodSchema),
]).describe("Parameters for visual search operations");
